import { formatISO } from "date-fns";
import { Entity } from "@common/types/entity";
import { ReportFormat } from "@common/helpers/reports";
import {
    ACCOUNTING_REPORT_LABELS,
    AccountingReportType,
} from "@common/types/reports/report-type";
import { ReportSettingRowVisibility } from "@common/types/reports/report-settings";
import { exportSchedulesReport } from "@api/schedulesReport.api";
import { AccountingReportFilters } from "@components/accounting/types";
import { pickXlsxExportRowVisibility } from "@components/accounting/xlsxExportRowVisibility";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { SchedulesReportParams } from "./schedulesReportTypes";

interface SchedulesReportDownloadParams {
    entity: Entity;
    format: ReportFormat;
    date?: Date;
}

interface UseSchedulesReportDownloadParams {
    filters: AccountingReportFilters;
    params: SchedulesReportParams;
    rowVisibility?: ReportSettingRowVisibility;
}

export function useSchedulesReportDownload({
    filters,
    params,
    rowVisibility,
}: UseSchedulesReportDownloadParams) {
    return useFileDownload(
        async ({ entity, format, date }: SchedulesReportDownloadParams) => {
            const response = await exportSchedulesReport({
                filters,
                params,
                format,
                rowVisibility: pickXlsxExportRowVisibility(
                    format,
                    rowVisibility,
                ),
            });
            if (!response) {
                return;
            }
            const reportTypeTitle =
                ACCOUNTING_REPORT_LABELS[AccountingReportType.SCHEDULES];
            const dateLabel = date
                ? formatISO(date, { representation: "date" })
                : "";
            saveBlobResponse(
                response,
                `${entity.name} - ${reportTypeTitle} - ${dateLabel}.${format}`,
            );
        },
    );
}
